import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-duotone-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-duotone-svg-icons/faAngleRight';
import { Grid, Box } from '@mui/material';
import { Pager } from '../../../../models/Pager';

interface PaginationProps {
    pager: Pager;
    onChangePage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ pager, onChangePage }) => {
    const pageNumbers: number[] = [];

    for (let i = 1; i <= pager.pages; i++) {
        pageNumbers.push(i);
    }

    if (pageNumbers.length === 1) pageNumbers.pop();

    const current = pager.current;
    const firstPage = 0;
    const previousPage = current - 1;
    const nextPage = current + 1;
    const lastPage = pager.pages - 1;

    if (pager.pages <= 1) return null;

    return (
        <Grid container justifyContent="center">
            <Grid
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'nowrap',
                }}
                className="defaultPagination"
            >
                {current >= 1 && (
                    <Box className="pagination-button" onClick={() => onChangePage(previousPage)}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </Box>
                )}

                <Box
                    className={`pagination-button ${current === 0 ? 'page-item active no-active-indicator' : 'page-item'}`}
                    onClick={() => onChangePage(firstPage)}
                >
                    1
                </Box>

                {pageNumbers.length > 6 && current > 3 && <Box className="pagination-button transparant">...</Box>}

                {pageNumbers.map((i) => {
                    if (i > 1 && i < pageNumbers.length) {
                        if (pageNumbers.length > 5) {
                            if ([current - 1, current, current + 1, current + 2, current + 3].includes(i - 1)) {
                                return (
                                    <Box
                                        key={i}
                                        className={`pagination-button ${current === i - 1 ? 'page-item active no-active-indicator' : 'page-item'}`}
                                        onClick={() => onChangePage(i - 1)}
                                    >
                                        {i}
                                    </Box>
                                );
                            }
                        } else {
                            return (
                                <Box
                                    key={i}
                                    className={`pagination-button ${current === i - 1 ? 'page-item active no-active-indicator' : 'page-item'}`}
                                    onClick={() => onChangePage(i - 1)}
                                >
                                    {i}
                                </Box>
                            );
                        }
                    }
                    return null;
                })}

                {pageNumbers.length > 6 && current < pageNumbers.length - 4 && (
                    <Box className="pagination-button transparant">...</Box>
                )}

                <Box
                    className={`pagination-button ${current === pageNumbers.length - 1 ? 'page-item active no-active-indicator' : 'page-item'}`}
                    onClick={() => onChangePage(lastPage)}
                >
                    {pageNumbers.length}
                </Box>

                {current <= pager.pages - 2 && (
                    <Box className="pagination-button" onClick={() => onChangePage(nextPage)}>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </Box>
                )}
            </Grid>
        </Grid>
    );
};

export default Pagination;
